var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      [
        _vm.company.id && _vm.detailOpened
          ? _c(
              "div",
              {
                staticClass: "border relative rounded-md p-5 bg-white",
                staticStyle: { "min-height": "calc(72vh - 0px)" },
              },
              [
                _c(
                  "div",
                  { staticClass: "flex justify-between items-center mb-2" },
                  [
                    _vm.company.attributes &&
                    _vm.company.attributes &&
                    _vm.company.attributes.name
                      ? _c(
                          "h3",
                          {
                            staticClass:
                              "text-xl font-semibold text-gray-900 lg:text-2xl dark:text-white",
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.company.attributes.name
                                    ? _vm.company.attributes.name
                                    : ""
                                ) +
                                "\n        "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass:
                          "text-gray-400 bg-transparent hover:bg-gray-100 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center",
                        attrs: {
                          type: "button",
                          "data-modal-toggle": "defaultModal",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.onClose()
                          },
                        },
                      },
                      [
                        _c(
                          "svg",
                          {
                            staticClass: "w-5 h-5",
                            attrs: {
                              fill: "currentColor",
                              viewBox: "0 0 20 20",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                "fill-rule": "evenodd",
                                d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
                                "clip-rule": "evenodd",
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(_vm.company.attributes.fullinfo),
                  },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "absolute bottom-5 right-5 left-5" }, [
                  _c(
                    "div",
                    { staticClass: "flex justify-between items-center" },
                    [
                      _c(
                        "h3",
                        {
                          staticClass:
                            "text-xl font-semibold text-gray-900 lg:text-2xl left-5 dark:text-white",
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.company.attributes.address
                                  ? _vm.company.attributes.address
                                  : ""
                              ) +
                              "\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass:
                            "right-5 items-center text-white focus:outline-none text-sm rounded-md bg-green-700 p-3",
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.$tools.phoneFormatter(
                                  _vm.company.attributes.phone
                                )
                              ) +
                              "\n          "
                          ),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.detailOpened
          ? _c("yandex-map", {
              attrs: {
                coords: _vm.getLocations,
                location: _vm.company.attributes,
              },
            })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }